
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iit-certificate",
      function () {
        return require("private-next-pages/iit-certificate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iit-certificate"])
      });
    }
  